import {
  Box,
  Link,
  Stack,
  Container,
  SvgIcon,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';
import ArrowLeftIcon from '@untitled-ui/icons-react/build/esm/ArrowLeft';
import { useState, type ChangeEvent, type FC, type MouseEvent } from 'react';
import { useSelector } from 'react-redux';

const RecentUploadedfiles = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const getRecentUploadedResponse = useSelector(
    (state: any) => state.getRecentUploadedReducer?.response?.data?.data
  );
  const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth={'xl'}>
        <Stack spacing={4}>
          <Stack spacing={4}>
            <div>
              <Link
                color="text.primary"
                component={RouterLink}
                href={paths.patients}
                sx={{
                  alignItems: 'center',
                  display: 'inline-flex',
                }}
                underline="hover"
              >
                <SvgIcon sx={{ mr: 1 }}>
                  <ArrowLeftIcon />
                </SvgIcon>
                <Typography variant="subtitle2">Back to Patient List</Typography>
              </Link>
            </div>
            <Stack
              alignItems="flex-start"
              direction={{
                xs: 'column',
                md: 'row',
              }}
              justifyContent="space-between"
              spacing={4}
            >
              <Stack spacing={1}>
                <Typography variant="h4">File Uploads History</Typography>
              </Stack>
            </Stack>
          </Stack>
          <Box sx={{ position: 'relative' }}>
            <Table sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Status</TableCell>
                  <TableCell>File Records</TableCell>
                  <TableCell>Imported On</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(getRecentUploadedResponse ?? []).length === 0 ? (
                  <TableRow>
                    <TableCell>No recently files uploaded</TableCell>
                  </TableRow>
                ) : (
                  (getRecentUploadedResponse ?? [])
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data: any) => {
                      return (
                        <TableRow key={data?.recordCount}>
                          <TableCell>{data?.status ? data?.status.toLowerCase() : '-'}</TableCell>
                          <TableCell>{data?.recordCount ? data?.recordCount : '-'}</TableCell>
                          <TableCell>{data?.importedOn ? data?.importedOn : '-'}</TableCell>
                        </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>

            <TablePagination
              component="div"
              count={getRecentUploadedResponse?.length || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10, 25, 50]}
            />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default RecentUploadedfiles;
